class ImagesCarousel extends HTMLElement {
  constructor() {
    super()

    this.adjustContent()

    this.sendingEvent = false
    this.receivedEvent = false

    this.sliderInited = false
    this.device = this.getDevice()

    if (this.mobileOnly) {
      this.toggleSlider()

      window.addEventListener("resize", () => {
        const device = this.getDevice()
        if (device != this.device) {
          this.device = device
          this.toggleSlider()
        }
      })
    } else {
      this.initSlider()
    }
  }

  adjustContent() {
    this.mediaItems.forEach((item) => item.classList.remove("hidden"))
  }

  toggleSlider() {
    if (this.device == "mobile") {
      this.initSlider()
    } else if (this.sliderElement && this.sliderInited) {
      this.sliderElement.destroy(true, true)
    }
  }

  initSlider() {
    this.sliderElement = new Swiper(this.querySelector(".js-slider"), {
      slidesPerView: this.count,
      initialSlide: 0,
      spaceBetween: this.space,
      effect: "slide",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
    this.sliderInited = true
    this.sliderElement.on("slideChange", ({ realIndex: after }) => {
      if (!this.receivedEvent) {
        this.dispatchEvent(
          new CustomEvent("SLIDER_CHANGED", {
            bubbles: true,
            composed: true,
            detail: {
              key: "sliderIndex",
              value: after,
            },
          })
        )
        this.sendingEvent = true
      }

      this.receivedEvent = false
    })
  }

  moveToIndex(index, forceMoving = false) {
    if (this.sliderInited && (!this.sendingEvent || forceMoving)) {
      this.sliderElement.slideTo(index)
      this.receivedEvent = true
    }
    this.sendingEvent = false
  }

  getDevice() {
    return window.innerWidth >= 750 ? "desktop" : "mobile"
  }

  get mobileOnly() {
    return this.getAttribute("data-mobile-only") == "true"
  }

  get mediaItems() {
    return this.querySelectorAll(".js-media-item")
  }

  get count() {
    return parseFloat(this.getAttribute("data-count") || "1")
  }

  get space() {
    return parseFloat(this.getAttribute("data-space") || "20")
  }
}

customElements.define("images-carousel", ImagesCarousel)
